import React, { useState } from 'react';

import CardDialog from '~/components/CardDialog';
import SkeletonTable from '~/components/core/Skeletons/SkeletonTable';
import type { ClaimMilestonesResponseClaimMilestoneModel as ClaimMilestone } from '~/server_shared/openapi/data-contracts';

import ClaimMilestoneEditDialog from './components/ClaimMilestoneEditDialog';
import ClaimMilestonesTable from './components/ClaimMilestonesTable';
import useClaimMilestones from './hooks/useClaimMilestones';
import TEXTS from './texts';

const ClaimMilestonesTab: React.FC = () => {
  const { milestones, isLoading, isError, record, clear } = useClaimMilestones();
  const [editedMilestone, setEditedMilestone] = useState<ClaimMilestone | null>(null);

  const handleCloseDialog = () => setEditedMilestone(null);

  return (
    <div className="m-12">
      <CardDialog title={TEXTS.title}>
        {isLoading || isError ? (
          <SkeletonTable rowsCount={3} columnsCount={3} isError={isError} />
        ) : (
          <ClaimMilestonesTable milestones={milestones} onEdit={setEditedMilestone} />
        )}
      </CardDialog>
      {/* Outside the list's loading and error states, so a failed reload cannot close an edit in progress. */}
      {editedMilestone ? (
        <ClaimMilestoneEditDialog
          milestone={editedMilestone}
          onSave={async (occurredOn) => {
            await record(editedMilestone.key, occurredOn);
            handleCloseDialog();
          }}
          onClear={async () => {
            await clear(editedMilestone.key);
            handleCloseDialog();
          }}
          onClose={handleCloseDialog}
        />
      ) : null}
    </div>
  );
};

export default ClaimMilestonesTab;
